module.exports = __webpack_public_path__ + "img/TS6201-303.a74b82a2.jpg";